/**
 * AppLoadingScreen - A minimal, Apple-like loading screen
 *
 * Displays a centered pulsing circle with the Flexireo app name.
 * Used during initial authentication loading state.
 */
export function AppLoadingScreen() {
  return (
    <div className="h-screen w-screen flex flex-col items-center justify-center bg-white">
      {/* Pulsing circle indicator */}
      <div className="w-16 h-16 rounded-full bg-slate-200 animate-pulse mb-6" />

      {/* App name */}
      <span className="text-xl font-medium text-slate-400">
        Flexireo
      </span>
    </div>
  );
}
